import { Chip, Stack, Tooltip, Typography } from "@mui/material";
import { EOrganizationValue } from "../types/companies.types";
import { EOrganizationForm } from "../types/partner.types";

interface IPartnerNameProps {
  name: string;
  organizationForm?: EOrganizationForm | EOrganizationValue;
}

export const PartnerLabel = ({ name, organizationForm }: IPartnerNameProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{ width: "100%", height: "100%" }}
    >
      {organizationForm === EOrganizationForm.PrivateIndividual && (
        <Chip
          label="ФЛ"
          size="small"
          sx={{
            height: 20,
            bgcolor: "#aa55b9",
            color: "#fff",
            fontSize: 10,
            fontWeight: 700,
            borderRadius: "999px",
            flexShrink: 0,
            "& .MuiChip-label": {
              px: 1,
            },
          }}
        />
      )}

      <Tooltip
        title={name}
        arrow
        placement="top"
        slotProps={{
          tooltip: {
            sx: {
              fontSize: "13px",
            },
          },
        }}
      >
        <Typography noWrap sx={{ minWidth: 0 }}>
          {name}
        </Typography>
      </Tooltip>
    </Stack>
  );
};
